import {
  SYNC_RESUME_DATA_REQUEST,
  SYNC_RESUME_DATA_SUCCESS,
  SYNC_RESUME_DATA_FAILURE,
  RESET_SYNC_RESUME_DATA,
} from "../../actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

const syncResumeDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SYNC_RESUME_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case SYNC_RESUME_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        success: true,
        error: null,
      };

    case SYNC_RESUME_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case RESET_SYNC_RESUME_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default syncResumeDataReducer; 